import { createSlice } from "@reduxjs/toolkit";
import { duotoneDark } from "react-syntax-highlighter/dist/esm/styles/prism";

const initialFloorsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  floorForEdit: undefined,
  roomForEdit: undefined,
  roomTypes: undefined,
  lastError: null,
  virtualHouse: null,
  houses: [],
  exportData: [],
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const floorsSlice = createSlice({
  name: "floors",
  initialState: initialFloorsState,
  reducers: {
    // virtualHouseCreated
    virtualHouseCreated: (state, action) => {
      const { data } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.virtualHouse = data;
    },

    // deleteHouse
    houseDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.houses = state.houses.filter((el) => el.id !== action.payload.id);
    },

    // findFloors
    allfloorsFetched: (state, action) => {
      const { data } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = data;
      state.totalCount = data.legnth;
    },

    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    // get Room Types
    roomTypesFetched: (state, action) => {
      state.actionsLoading = false;
      state.roomTypes = action.payload.roomTypes;
      state.error = null;
    },

    // getFloorById
    floorRoomsFetched: (state, action) => {
      state.actionsLoading = false;
      const copyEntities = state.entities;
      const floorForEdit = state.floorForEdit;
      const rooms = action.payload.rooms;
      // action.payload.rooms
      // action.payload.floorId
      const index = copyEntities.findIndex(
        (x) => x.id === action.payload.floorId
      );
      copyEntities[index] = { ...copyEntities[index], rooms };

      state.entities = copyEntities;
      state.floorForEdit = { ...floorForEdit, rooms };
      state.error = null;
    },

    // getFloorById
    floorFetched: (state, action) => {
      state.actionsLoading = false;
      state.floorForEdit = action.payload.floorForEdit;
      state.error = null;
    },

    housesFetched: (state, action) => {
      const { houses } = action.payload;
      state.houses = houses;
      state.listLoading = false;
      state.error = null;
    },

    // findFloors
    floorsFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // createFloor
    floorCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.data);
    },
    // updateFloor
    floorUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map((entity) => {
        if (entity.id === action.payload.floor.id) {
          return action.payload.floor;
        }
        return entity;
      });
    },
    // deleteFloor
    floorDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        (el) => el.id !== action.payload.id
      );
    },

    // export Floor
    floorExportFetched: (state, action) => {
      state.actionsLoading = false;
      state.exportData = action.payload.data;
      state.error = null;
    },

    // Room
    roomFetched: (state, action) => {
      state.actionsLoading = false;
      state.roomForEdit = action.payload.roomForEdit;
      state.error = null;
    },
    // findFloors
    roomsFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // createRoom
    roomCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities = state.entities.map((entity) => {
        if (entity.id === action.payload.room.floorId) {
          entity.rooms.push(action.payload.room);
        }
        return entity;
      });
    },
    // updateFloor
    roomUpdated: (state, action) => {
      //debugger;
      state.error = null;
      state.actionsLoading = false;

      // state.entities = state.entities.map(entity => {
      //   console.log('roomUpdated', entity);
      //   if (entity.id === parseInt(action.payload.room.floorId)) {
      //     entity = entity.rooms.map(item => {
      //       console.log('roomUpdated',item);
      //       if (item.id === action.payload.room.id) {
      //         return action.payload.room;
      //       }
      //       return item;
      //     });
      //   }
      //   return entity;
      // });
    },
    // deleteFloor
    roomDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      //state.entities = state.entities.filter(el => el.id !== action.payload.id);

      state.entities = state.entities.map((entity) => {
        if (entity.id === parseInt(action.payload.floorId)) {
          entity.rooms = entity.rooms.filter(
            (el) => el.id !== action.payload.id
          );
        }
        return entity;
      });
    },
  },
});
